import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-acd-settings-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAcdSettingsIconProps extends SvgIconProps  {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfAcdSettingsIcon(props: CcfAcdSettingsIconProps) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M18.1999 10.5V9.5L19.6999 8.1C19.9999 7.8 20.0999 7.4 19.8999 7.1L19.0999 5C18.9999 4.7 18.5999 4.5 18.1999 4.4L16.1999 4.5L15.4999 3.8L15.5999 1.8C15.5999 1.4 15.3999 1.1 14.9999 0.9L12.8999 0C12.7999 0 12.6999 0 12.4999 0C12.2999 0 11.9999 0.1 11.7999 0.3L10.3999 1.8H9.3999L8.0999 0.3C7.9999 0.1 7.6999 0 7.4999 0C7.2999 0 7.1999 0 7.0999 0.1L4.9999 0.9C4.6999 1.1 4.3999 1.4 4.4999 1.8L4.5999 3.8L3.8999 4.6L1.8999 4.5C1.3999 4.5 1.0999 4.7 0.899901 5L0.0999014 7.1C-9.85488e-05 7.5 -9.85563e-05 7.9 0.299901 8.1L1.7999 9.5V10.5L0.299901 11.9C-9.85563e-05 12.2 -0.100099 12.6 0.0999014 12.9L0.899901 15C0.999901 15.3 1.3999 15.6 1.7999 15.6L3.7999 15.5L4.4999 16.2L4.3999 18.2C4.3999 18.6 4.5999 18.9 4.9999 19.1L7.0999 20C7.1999 20 7.2999 20 7.4999 20C7.7999 20 7.9999 19.9 8.1999 19.7L9.5999 18.2H10.5999L11.9999 19.7C12.1999 19.9 12.3999 20 12.6999 20C12.7999 20 12.8999 20 12.9999 19.9L15.0999 19C15.4999 18.9 15.6999 18.5 15.6999 18.1L15.5999 16.1L16.2999 15.4L18.3999 15.5C18.7999 15.5 19.0999 15.3 19.1999 14.9L20.0999 12.8C20.1999 12.5 20.1999 12 19.8999 11.8L18.1999 10.5ZM17.4999 13.5L16.1999 13.4H15.2999L13.3999 15.3V16.2L13.4999 17.5L12.7999 17.8L11.9999 16.8L11.3999 16.1H8.5999L7.9999 16.8L7.1999 17.7L6.4999 17.4L6.5999 16.1V15.2L5.9999 14.7L4.6999 13.4H3.7999L2.4999 13.5L2.1999 12.8L3.1999 12L3.8999 11.4V8.6L3.1999 8L2.1999 7.2L2.4999 6.5L3.7999 6.6H4.6999L6.5999 4.7V3.8L6.4999 2.5L7.1999 2.2L7.9999 3.2L8.5999 3.9H11.3999L11.9999 3.2L12.7999 2.3L13.4999 2.6L13.3999 3.9V4.8L13.9999 5.3L15.2999 6.6H16.1999L17.4999 6.5L17.7999 7.2L16.7999 8L16.0999 8.6V11.4L16.7999 12L17.6999 12.8L17.4999 13.5Z"
        fill="#FF9400"
      />
      <path
        d="M9.9999 6.3C7.9999 6.3 6.2999 8 6.2999 10C6.2999 12 7.9999 13.7 9.9999 13.7C11.9999 13.7 13.6999 12 13.6999 10C13.6999 8 11.9999 6.3 9.9999 6.3ZM9.9999 11.7C9.0999 11.7 8.2999 10.9 8.2999 10C8.2999 9.1 9.0999 8.3 9.9999 8.3C10.8999 8.3 11.6999 9.1 11.6999 10C11.6999 10.9 10.8999 11.7 9.9999 11.7Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfAcdSettingsIcon;
